import React from 'react';
import './Cali.css'; 

const Ipiales = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKIP.pdf" target="_blank" rel="noreferrer">Aeropuerto San Luis</a></h1>
    </div>
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 08</th>                      
          </tr> 
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5B.pdf" target="_blank" rel="noreferrer">EGOB5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5B.pdf" target="_blank" rel="noreferrer">GAVE5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/PAMB7B.pdf" target="_blank" rel="noreferrer">PAMB7B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1C.pdf" target="_blank" rel="noreferrer">ESAR1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1C.pdf" target="_blank" rel="noreferrer">DUBK1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1C.pdf" target="_blank" rel="noreferrer">PAMB1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1G - SKIP.pdf" target="_blank" rel="noreferrer">EGOB1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1G - SKIP.pdf" target="_blank" rel="noreferrer">MERC1D</a></th>
          </tr>        
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5C.pdf" target="_blank">EGOB5C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5C.pdf" target="_blank">GAVE5C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5C.pdf" target="_blank">PAMB4C</a></th>
          </tr>   
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1B.pdf" target="_blank" rel="noreferrer">DUBK1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1B.pdf" target="_blank" rel="noreferrer">ESAR1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/DUBK1B.pdf" target="_blank" rel="noreferrer">PAMB1F</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1F.pdf" target="_blank" rel="noreferrer">EGOB1F</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1F.pdf" target="_blank" rel="noreferrer">MER1C</a></th>
          </tr>     
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 08</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKIP/EGOB5A.pdf" target="_blank" rel="noreferrer">EGOB5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/GAVE5A.pdf" target="_blank" rel="noreferrer">GAVE5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/PAMB8A.pdf" target="_blank" rel="noreferrer">PAMB8A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB2D.pdf" target="_blank" rel="noreferrer">EGOB2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB2D.pdf" target="_blank" rel="noreferrer">GAVE2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB2D.pdf" target="_blank" rel="noreferrer">PAMB2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB2D.pdf" target="_blank" rel="noreferrer">DUBK1A</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1E.pdf" target="_blank" rel="noreferrer">EGOB1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1E.pdf" target="_blank" rel="noreferrer">GAVE1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/EGOB1E.pdf" target="_blank" rel="noreferrer">PAMB1E</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 08</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/VOR08.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/RNP08.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 26</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKIP/RNP26.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Ipiales;